var BrandclubEventType;
(function (BrandclubEventType) {
    BrandclubEventType["PageView"] = "PageView";
    BrandclubEventType["NavigateToRetailer"] = "NavigateToRetailer";
    BrandclubEventType["AddToCart"] = "AddToCart";
    BrandclubEventType["OrderSubmitted"] = "OrderSubmitted";
})(BrandclubEventType || (BrandclubEventType = {}));

export { BrandclubEventType };
//# sourceMappingURL=types.js.map
